/* eslint-disable react/no-danger */
import React from 'react';
import BoxedContainer from '../layouts/BoxedContainer';

export default function MedicalFacilities({ data }) {
  return (
    <section className="bg-bg-1 lg:pt-[95px] pt-[70px] lg:pb-[158px] pb-[70px]">
      <BoxedContainer className="regular">
        <div className="flex flex-col lg:gap-y-[39px] gap-y-[20px] xl:max-w-[970px]">
          <h3
            className="text-primary font-roboto-condensed-bold lg:text-2xl text-[35px]
          leading-9 uppercase"
          >
            {data.title}
          </h3>
          <div
            className="font-roboto-regular lg:text-base text-[15px] leading-6 flex flex-col
            lg:gap-y-4 gap-y-3 strong-content:font-roboto-bold"
            dangerouslySetInnerHTML={{ __html: data.detailsText }}
          />
        </div>
      </BoxedContainer>
    </section>
  );
}
